export default "__VITE_ASSET__CxjtaFz3__"